/**
 * RolePickerPanel — split out of AuthHub.jsx in 2026-02.
 */
import { useState } from "react";

import { toast } from "sonner";
import { Scales, UserCircle, ArrowLeft } from "@phosphor-icons/react";

import {
  GLASS, FieldLabel, TextInput, PasswordInput, DisplayField,
  GoldButton, GhostBackButton, useAuthShellBackground, parseCardDate,
} from "./_shared";

export default function RolePickerPanel({ onPickLawyer, onPickClient }) {  return (
    <section className={`${GLASS} p-5 sm:p-6`} data-testid="role-picker">
      <h1 className="text-[22px] font-extrabold text-[#0A192F] leading-tight">إنشاء حساب جديد</h1>
      <p className="text-[12.5px] text-[#5A6470] mt-1 mb-5">اختَر نوع الحساب الذي يناسبك للبدء.</p>

      <button
        type="button"
        onClick={onPickLawyer}
        data-testid="role-lawyer"
        className="w-full flex items-center gap-4 p-4 rounded-[22px] bg-white/75 border border-white/70
                   hover:bg-white hover:border-[#D4AF37] active:scale-[0.99] transition-all text-right"
      >
        <div className="w-12 h-12 rounded-full bg-[#FFFBF0] ring-1 ring-[#D4AF37]/60 text-[#A88425]
                        flex items-center justify-center shrink-0">
          <Scales size={26} weight="duotone" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[16px] font-extrabold text-[#0A192F]">محامٍ</div>
          <div className="text-[12px] text-[#5A6470] leading-snug mt-0.5">
            تسجيل بهويّة نقابة المحامين العراقيّة — وصول لكلّ أدوات LexIQ.
          </div>
        </div>
        <ArrowLeft size={18} weight="bold" className="text-[#0A192F] shrink-0" />
      </button>

      <button
        type="button"
        onClick={onPickClient}
        data-testid="role-client"
        className="w-full flex items-center gap-4 p-4 rounded-[22px] bg-white/75 border border-white/70
                   hover:bg-white hover:border-[#D4AF37] active:scale-[0.99] transition-all text-right mt-3"
      >
        <div className="w-12 h-12 rounded-full bg-white/85 ring-1 ring-white/80 text-[#0A192F]
                        flex items-center justify-center shrink-0">
          <UserCircle size={26} weight="duotone" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[16px] font-extrabold text-[#0A192F]">زائر / عميل</div>
          <div className="text-[12px] text-[#5A6470] leading-snug mt-0.5">
            تصفُّح القوانين، المحاكم، ودليل المحامين — بدون هويّة نقابة.
          </div>
        </div>
        <ArrowLeft size={18} weight="bold" className="text-[#0A192F] shrink-0" />
      </button>
    </section>
  );
}
